import { useState } from "react";

import Button from "@mui/material/Button";
import { v4 as uuid } from "uuid";

import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogMessage from "../ui/omniDialogMessage";
import DialogTitle from "../ui/omniDialogTitle";
import OmniTextField from "../ui/omniTextField";

const TextInputDialog = props => {
  const {
    open,
    onClose,
    onAccept,
    dialogTitle = "User Input",
    dialogMessage = "",
    inputLabel = "Your Answer",
    inputPlaceholder = "Answer Here",
    okMessage = "Ok",
    cancelMessage = "Cancel",
    maxWidth = "xs",
    fullWidth = true,
    defaultValue = "",
    multiline = false,
    rows = 7,
  } = props;

  const [userInput, setUserInput] = useState(defaultValue);

  const onAcceptHandler = () => {
    onAccept(userInput);
  };

  const onCloseHandler = () => {
    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={() => onCloseHandler}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>
      <DialogContent>
        {dialogMessage && <DialogMessage>{dialogMessage}</DialogMessage>}
        <OmniTextField
          label={inputLabel}
          type="textInput"
          variant="outlined"
          name={uuid()} //prevents AutoComplete Suggestions
          id={"displayName"}
          rowCount={rows}
          multiline={multiline}
          value={userInput}
          onChange={event => {
            setUserInput(event.target.value);
          }}
          placeholder={inputPlaceholder}
        />
      </DialogContent>
      <DialogActions>
        {cancelMessage && (
          <Button onClick={onCloseHandler} color="secondary" variant="contained">
            {cancelMessage}
          </Button>
        )}
        <Button
          disabled={!userInput}
          onClick={onAcceptHandler}
          color="secondary"
          variant="contained"
        >
          {okMessage}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TextInputDialog;
